import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import * as _ from 'lodash';

@Component({
    selector: 'ea-radio-header',
    templateUrl: './ea-radio-header.component.html',
    styleUrls: ['./ea-radio-header.component.scss'],
    standalone: false
})
export class EaRadioHeaderComponent implements OnInit, AfterViewInit {
  @Input() set choices(choices) {
    this._choices = [];
    _.forEach(choices, choice =>
      this._choices.push({
        id: choice[0],
        label: choice[1],
        value: choice[2],
        checked: choice[3] ? true : false,
      }),
    );

    if (!_.find(this._choices, 'checked')) this._choices[0].checked = true;
  }
  _choices = [];
  @Output() pick: EventEmitter<any> = new EventEmitter();

  @ViewChild('switchIndicator') indicator: ElementRef;
  @ViewChild('labels', { read: ElementRef }) labelRefs: ElementRef[];

  selected: HTMLElement;
  hash =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.selected = this.labelRefs.find(
        labelRef =>
          labelRef.nativeElement.getAttribute('for') ===
          `${_.find(this._choices, 'checked').id}_${this.hash}`,
      ).nativeElement;
      this.selected.click();
    }, 0);
  }

  handleChange(evt) {
    var target = evt.target;
    if (target.checked) {
      this.selected = this.labelRefs.find(
        labelRef =>
          labelRef.nativeElement.getAttribute('for') === evt.target.id,
      ).nativeElement;

      const selectedPosition = this.selected.getBoundingClientRect().left;
      const indicatorWidth = this.selected.offsetWidth;
      this.indicator.nativeElement.style.width = `${indicatorWidth}px`;
      this.indicator.nativeElement.style.transform = `translateX(${selectedPosition}px)`;

      this.pick.emit(
        _.find(this._choices, [
          'id',
          evt.target.id.substring(0, evt.target.id.lastIndexOf('_')),
        ]).value,
      );
    }
  }
}
